// src/components/Footer.jsx
import "../assets/styles.css";

const currentYear = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="w-full bg-black py-4 sm:py-6 lg:py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 lg:gap-6">
          
          {/* Left: Copyright */}
          <div className="text-white text-xs sm:text-sm lg:text-base text-center sm:text-left order-2 sm:order-1">
            <span>© {currentYear}. </span>
            <span className="text-[#2E7D32] font-medium hover:text-green-400 transition-colors duration-200">
              PADPro Piedmont Adult Day Program
            </span>
            <span>. All rights reserved.</span>
          </div>
          
          {/* Right: Designed by */}
          <div className="text-white text-xs sm:text-sm lg:text-base text-center sm:text-right order-1 sm:order-2">
            <span>Designed & Developed by </span>
            <span className="font-medium text-gray-300 hover:text-white transition-colors duration-200">
              BizSolutions
            </span>
            <span>.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}